export const fr = {
  title: `Alcool et THC`,
  p1: `Une personne épileptique peut-elle consommer de l’alcool ? Il est reconnu que la consommation d’alcool peut aggraver les crises, surtout dans les cas où l’épilepsie est mal contrôlée. Il est possible de consommer de l’alcool à faible quantité et pas si cette prise est associée à un manque de sommeil. Cette décision dépend aussi de la situation de chaque patient: nous vous recommandons donc d’en parler à votre médecin.`,
  p2: `Les mêmes principes gouvernent la prise de THC.`
};
